/* eslint-disable react/prop-types */
import React from 'react';

const BuilderConstructorGridInputContext = React.createContext();

const useBuilderConstructorGridInputs = () => {
  return React.useContext(BuilderConstructorGridInputContext) || {};
};

const BuilderConstructorGridInputProvider = ({ children, value }) => {
  return (
    <BuilderConstructorGridInputContext.Provider value={value}>
      {children}
    </BuilderConstructorGridInputContext.Provider>
  );
};

export default useBuilderConstructorGridInputs;
export { BuilderConstructorGridInputProvider };
